import { Injectable } from '@angular/core';

import { IPickup } from '../../lib/lib-shared/api/All.Type';

@Injectable({
  providedIn: 'root'
})
export class PickupService {
  private pickup: IPickup | null = null;
  private pickupMode = false;

  constructor() {
  }

  setPickup(pickup: IPickup | null) {
    this.pickup = pickup;
  }

  getPickup(): IPickup | null {
    return this.pickup;
  }

  setPickupMode(value: boolean) {
    this.pickupMode = value;
  }

  getPickupMode(): boolean {
    return this.pickupMode;
  }
}
